import styles from './document-banner.module.css';

export function CompanyInformationDocumentBanner() {
  return (
    <a
      href='/common/file/service_guide.pdf'
      target='_blank'
      rel='noreferrer'
      className={styles.banner}
    >
      <span className={styles.lead}>PR TIMESのご利用について</span>
      <span className={styles.download}>
        <DownloadIcon />
        <span>資料をダウンロード</span>
      </span>
    </a>
  );
}

function DownloadIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 21 19'
      fill='none'
      aria-hidden='true'
    >
      <g clipPath='url(#clip0_8070_58895)'>
        <path
          d='M0.5 13.5V16.5C0.5 17.593 1.407 18.5 2.5 18.5H18.5C19.593 18.5 20.5 17.593 20.5 16.5V13.5H18.5V16.5H2.5V13.5H0.5ZM9.5 0.5V11.086L5.207 6.793L3.793 8.207L10.5 14.914L17.207 8.207L15.793 6.793L11.5 11.086V0.5H9.5Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_8070_58895'>
          <rect
            width='20'
            height='18'
            fill='white'
            transform='translate(0.5 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
